import type { FaireProductEntity } from "../../entity_types/product";

export const p_c89n94uar2: FaireProductEntity = {
  token: "p_c89n94uar2",
  type: "product",
  name: "Coaster Set, Cheese",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/f7e56c6c3a7f282c11daab51582fcb7a3558a7c79a409a3350a3914f03becb4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a5da6405c4469fdc7a7382fa3956e273948f688a2bb1d93d3e9648b6e3b3d82.jpeg",
    "https://cdn.faire.com/fastly/b70ed18f9274b6456e84554844db51f88a7830e455d67476be64352be7f4ed23.jpeg",
    "https://cdn.faire.com/fastly/4cc7eb56a7757dba08714cce372af8ac042e4f4bfa8c975130f9e0a8d397346f.jpeg",
    "https://cdn.faire.com/fastly/d2a7f7b3b513bf2fc71b2f81692dc10a6e828e46c7ba90b6f55dc25a5bf9142b.jpeg",
    "https://cdn.faire.com/fastly/ec50c096866cd2653504f45c185e97cbb501b14e9c24c379e12927d0976f6cb1.jpeg",
    "https://cdn.faire.com/fastly/a807b06e51bab99ec0b8238001e4314d582784161bd2cdcbe48e0185f389f19d.jpeg",
    "https://cdn.faire.com/fastly/18ddd528c96e28ec1c5864cd544e3f82ff8604b97bf6004aab96a9f7a3ce201e.jpeg",
    "https://cdn.faire.com/fastly/8e719271fbd9c22c2b0b3a31e40b222e903a6d7cc8fb5284815885970ea73099.jpeg",
    "https://cdn.faire.com/fastly/9878c13797ee72f22c0a7eb9683936a9cb7b409f1a7d0aa93a5c59193570d47b.jpeg"
  ],
  priceDollars: 11,
  description: "Say cheese! This incredible set of coasters knows how to entertain. Made with a sturdy leatherette, you'll get one gouda, one brie, one blue cheese, and one Swiss. They're the perfect thing to bust out at your next party or gift to a great host.\n\nFeatures:\nSet of 4 leatherette coasters in cheese-inspired designs\nIncludes gouda, brie, blue cheese, and Swiss styles\nProtects surfaces from heat, moisture, and spills\nDurable, lightweight, and easy to clean\nDesigned in Bando’s signature bright and playful style\n\nIdeal For:\nGift shops and home décor boutiques\nKitchenware and entertaining retailers\nHosts, food lovers, and cheese enthusiasts\nWholesale buyers seeking fun, giftable bar and tabletop accessories",
  tags: [],
  msrpDollars: 22.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:41.895Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
